<template>
  <div>
    <el-container >
      <el-header style="padding:20px 0 0 20px!important;height:auto">
        <el-button
          v-if="data.length < 3"
          type="primary"
          icon="el-icon-add"
          @click="handleCommand({ command: 'add' })"
        >添加</el-button>
      </el-header>
      <el-main>
        <el-row :gutter="10">
          <el-col :span="8" v-for="item in data" :key="item.id">
            <el-card class="box-card">
              <el-row>
                <el-col :span="10">
                  <img :src="'img/' + item.type + '.png'" class="image" />
                </el-col>
                <el-col :span="14">
                  <div class="divText">{{ item.corpName }}</div>
                </el-col>
              </el-row>
              <div class="bottom clearfix">
                <el-row type="flex" justify="space-around">
                  <el-col :span="4.8">
                    <i
                      class="el-icon-edit"
                      style=" cursor: pointer "
                      @click="handleCommand({ command: 'edit', row: item })"
                    >
                      <font class="li">编辑</font>
                    </i>
                  </el-col>
                  <el-col :span="4.8" v-if="item.type == 'weChatWork' || item.type == 'dingtalk'">
                    <i
                      class="el-icon-setting"
                      style=" cursor: pointer "
                      @click="handleCommand({ command: 'setAgent', row: item })"
                    >
                      <font class="li">配置应用</font>
                    </i>
                  </el-col>
                  <el-col :span="4.8" v-if="item.type == 'weChatOffAcc'">
                    <i class="el-icon-share" style=" cursor: pointer " @click="getMenu(item)">
                      <font class="li">生成菜单</font>
                    </i>
                  </el-col>
                  <el-col :span="4.8" v-if="item.type == 'weChatOffAcc'">
                    <i
                      class="el-icon-setting"
                      style=" cursor: pointer "
                      @click="openTempMsgIdDialog(item)"
                    >
                      <font class="li">设置模板消息ID</font>
                    </i>
                  </el-col>
                  <el-col :span="4.8">
                    <i
                      class="el-icon-delete"
                      style=" cursor: pointer "
                      @click="handleCommand({ command: 'del', row: item })"
                    >
                      <font class="li">删除</font>
                    </i>
                  </el-col>
                </el-row>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
    <el-dialog
      width="40%"
      :title="title"
      :visible="dialogVisible"
      :before-close="handleClose"
      append-to-body
      :close-on-click-modal="false"
    >
      <el-form
        :disabled="systemDisabled"
        v-model="sysExternalUnite"
        data-vv-scope="sysExternalUniteForm"
      >
        <eco-form-item label="集成类型" prop="type" label-width="120px" class="identity-input-width">
          <eco-select
            :disabled="sysExternalUnite.id != ''"
            v-model="sysExternalUnite.type"
            :options="typeList"
            :validate="{ required: true }"
            placeholder="请选择集成类型"
          />
        </eco-form-item>
        <eco-form-item
          label-width="120px"
          class="identity-input-width"
          prop="corpId"
          v-if="sysExternalUnite.type"
        >
          <template slot="label" v-if="sysExternalUnite.type == 'weChatWork'">
            <el-tooltip placement="top">
              <div slot="content">
                企业id。第三方平台给予的企业标识。 在
                <a
                  href="ecotps://work.weixin.qq.com/wework_admin/frame#profile"
                  target="_blank"
                  style="color:#90c2f7;text-decoration:underline"
                >企业微信开放平台</a>的基本信息
              </div>
              <i class="el-icon-question" />
            </el-tooltip>
            <span>corpId</span>
          </template>
          <template slot="label" v-else-if="sysExternalUnite.type == 'dingtalk'">
            <el-tooltip placement="top">
              <div slot="content">
                企业id。第三方平台给予的企业标识。 在
                <a
                  href="ecotps://open-dev.dingtalk.com/#/corpAuthInfo"
                  target="_blank"
                  style="color:#90c2f7;text-decoration:underline"
                >钉钉开放平台</a>的基本信息-开发信息(旧版)
              </div>
              <i class="el-icon-question" />
            </el-tooltip>
            <span>corpId</span>
          </template>
          <template slot="label" v-else-if="sysExternalUnite.type == 'weChatOffAcc'">
            <el-tooltip placement="top">
              <div slot="content">开发者ID(AppID)。在微信公众平台-开发-基本配置</div>
              <i class="el-icon-question" />
            </el-tooltip>
            <span>AppID</span>
          </template>

          <eco-input
            v-model="sysExternalUnite.corpId"
            autocomplete="off"
            :validate="{ required: true }"
            placeholder="请输入corpId"
          ></eco-input>
        </eco-form-item>

        <eco-form-item
          label-width="120px"
          class="identity-input-width"
          prop="corpSecret"
          v-if="
            sysExternalUnite.type == 'weChatWork' ||
              sysExternalUnite.type == 'weChatOffAcc'
          "
        >
          <template slot="label" v-if="sysExternalUnite.type == 'weChatWork'">
            <el-tooltip placement="top">
              <div slot="content">
                第三方同步通讯录的secret。 在
                <a
                  href="ecotps://work.weixin.qq.com/wework_admin/frame#apps/contactsApi"
                  target="_blank"
                  style="color:#90c2f7;text-decoration:underline"
                >企业微信</a>的管理工具-通讯录同步
              </div>
              <i class="el-icon-question" />
            </el-tooltip>
            <span>corpSecret</span>
          </template>
          <template slot="label" v-else>
            <el-tooltip placement="top">
              <div slot="content">开发者密码(AppSecret)。在微信公众平台-开发-基本配置</div>
              <i class="el-icon-question" />
            </el-tooltip>
            <span>AppSecret</span>
          </template>
          <eco-input
            v-model="sysExternalUnite.corpSecret"
            autocomplete="off"
            :validate="{ required: true }"
            placeholder="请输入corpSecret"
          ></eco-input>
        </eco-form-item>

        <eco-form-item prop="baseUrl" label-width="120px" class="identity-input-width">
          <template slot="label">
            <el-tooltip placement="top">
              <div slot="content">
                格式：【http或https】+【域名】+【端口号】+【根路径】
                如：http://www.eco.org:8280/mobilevue
              </div>
              <i class="el-icon-question" />
            </el-tooltip>
            <span>移动端地址</span>
          </template>
          <eco-input
            v-model="sysExternalUnite.baseUrl"
            autocomplete="off"
            :validate="{ required: true }"
            placeholder="请输入本系统地址"
          ></eco-input>
        </eco-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <fe-submit-button
          v-show="!systemDisabled"
          :url="saveSysExternalUnite()"
          :model="sysExternalUnite"
          :is-submit="isSubmit"
          request-method="POST"
          scope-name="sysExternalUniteForm"
          @before-save-data="beforeSaveData"
          @after-save-data="afterSaveData"
        >{{ $t("eip.common.save") }}</fe-submit-button>
        <el-button @click="dialogCancle()">
          {{
          $t("eip.common.cancel")
          }}
        </el-button>
      </div>
    </el-dialog>

    <eco-sidebar-dialog
    destroy-on-close
      width="28%"
      title="配置应用"
      :visible="sysExtUniSetAgentVisible"
      @before-close="handleClose"
      append-to-body
    >
      <el-form v-model="sysExternalUnite" data-vv-scope="sysExtUniSetAgentForm" style="padding: 20px">
        <eco-form-item label-width="120px" class="identity-input-width" prop="agentId">
          <template slot="label">
            <el-tooltip placement="top">
              <div slot="content">
                第三方应用id。
                <span v-if="sysExternalUnite.type == 'weChatWork'">
                  在
                  <a
                    href="ecotps://work.weixin.qq.com/wework_admin/frame#apps"
                    target="_blank"
                    style="color:#90c2f7;text-decoration:underline"
                  >企业微信</a>的应用管理里
                </span>
                <span v-else>
                  在
                  <a
                    href="ecotps://open-dev.dingtalk.com/#/corph5"
                    target="_blank"
                    style="color:#90c2f7;text-decoration:underline"
                  >钉钉开放平台</a>企业内部开发-H5微应用里-进入微应用-【应用信息-查看详情】
                </span>
              </div>
              <i class="el-icon-question" />
            </el-tooltip>
            <span>agentId</span>
          </template>

          <eco-input
            v-model="sysExternalUnite.agentId"
            autocomplete="off"
            :validate="{ required: true }"
            placeholder="agentId"
          ></eco-input>
        </eco-form-item>
        <eco-form-item
          label-width="120px"
          class="identity-input-width"
          prop="appKey"
          v-if="sysExternalUnite.type == 'dingtalk'"
        >
          <template slot="label">
            <el-tooltip placement="top">
              <div slot="content">
                第三方应用key。 在
                <a
                  href="ecotps://open-dev.dingtalk.com/#/corph5"
                  target="_blank"
                  style="color:#90c2f7;text-decoration:underline"
                >钉钉开放平台</a>企业内部开发-H5微应用里-进入微应用-【应用信息-查看详情】
              </div>
              <i class="el-icon-question" />
            </el-tooltip>
            <span>appKey</span>
          </template>

          <eco-input
            v-model="sysExternalUnite.agentKey"
            autocomplete="off"
            :validate="{ required: true }"
            placeholder="请输入appKey"
          ></eco-input>
        </eco-form-item>
         <eco-form-item
          label-width="120px"
          class="identity-input-width"
          prop="codeId"
          v-if="sysExternalUnite.type == 'dingtalk'"
        >
          <template slot="label">
            <el-tooltip placement="top">
              <div slot="content">
                第三方应用key。 在
                <a
                  href="ecotps://open-dev.dingtalk.com/#/corph5"
                  target="_blank"
                  style="color:#90c2f7;text-decoration:underline"
                >钉钉开放平台</a>企业内部开发-H5微应用里-进入微应用-【应用信息-查看详情】
              </div>
              <i class="el-icon-question" />
            </el-tooltip>
            <span>codeId</span>
          </template>

          <eco-input
            v-model="sysExternalUnite.codeId"
            autocomplete="off"
            :validate="{ required: true }"
            placeholder="请输入codeId"
          ></eco-input>
        </eco-form-item>
        <eco-form-item
          label-width="120px"
          class="identity-input-width"
          prop="codeSecret"
          v-if="sysExternalUnite.type == 'dingtalk'"
        >
          <template slot="label">
            <el-tooltip placement="top">
              <div slot="content">
                第三方应用key。 在
                <a
                  href="ecotps://open-dev.dingtalk.com/#/corph5"
                  target="_blank"
                  style="color:#90c2f7;text-decoration:underline"
                >钉钉开放平台</a>企业内部开发-H5微应用里-进入微应用-【应用信息-查看详情】
              </div>
              <i class="el-icon-question" />
            </el-tooltip>
            <span>codeSecret</span>
          </template>

          <eco-input
            v-model="sysExternalUnite.codeSecret"
            autocomplete="off"
            :validate="{ required: true }"
            placeholder="请输入codeSecret"
          ></eco-input>
        </eco-form-item>
        <eco-form-item label-width="120px" class="identity-input-width" prop="agentSecret">
          <template slot="label">
            <el-tooltip placement="top">
              <div slot="content">
                第三方应用secret。
                <span v-if="sysExternalUnite.type == 'weChatWork'">
                  在
                  <a
                    href="ecotps://work.weixin.qq.com/wework_admin/frame#apps"
                    target="_blank"
                    style="color:#90c2f7;text-decoration:underline"
                  >企业微信</a>的应用管理里
                </span>
                <span v-else>
                  在
                  <a
                    href="ecotps://open-dev.dingtalk.com/#/corph5"
                    target="_blank"
                    style="color:#90c2f7;text-decoration:underline"
                  >钉钉开放平台</a>企业内部开发-H5微应用里-进入微应用-【应用信息-查看详情】
                </span>
              </div>
              <i class="el-icon-question" />
            </el-tooltip>
            <span>应用secret</span>
          </template>

          <eco-input
            v-model="sysExternalUnite.agentSecret"
            autocomplete="off"
            :validate="{ required: true }"
            placeholder="请输入agentSecret"
          ></eco-input>
        </eco-form-item>


        <eco-form-item label-width="120px" prop="menuUrl">
          <template slot="label">
            <el-tooltip placement="top" v-if="sysExternalUnite.type == 'dingtalk'">
              <div slot="content">
                钉钉不支持发布菜单，请自行拷贝并配置在
                <a
                  href="ecotps://open-dev.dingtalk.com/#/corph5"
                  target="_blank"
                  style="color:#90c2f7;text-decoration:underline"
                >钉钉开放平台</a>
                企业内部开发-H5微应用里-进入微应用-【应用信息-查看详情】-应用首页地址
              </div>
              <i class="el-icon-question" />
            </el-tooltip>
            <span>菜单url</span>
          </template>
          <eco-input
            type="textarea"
            prop="menuUrl"
            :rows="18"
            v-model="sysExternalUnite.menuUrl"
            autocomplete="off"
            :validate="{ required: true }"
            placeholder="请输入菜单名称"
          ></eco-input>
          <el-button
            type="primary"
            icon="el-icon-printer"
            @click="generateMenuUrl(sysExternalUnite)"
          >一键生成</el-button>
        </eco-form-item>
      </el-form>
      <div class="demo-drawer__footer">
        <el-button @click="handleClose">
          {{
          $t("eip.common.cancel")
          }}
        </el-button>
        <fe-submit-button
          url="/portal/sysExternalUnite/v1/saveAgent"
          context="portal"
          :model="sysExternalUnite"
          scope-name="sysExtUniSetAgentForm"
          @before-save-data="sysExternalUnite.isPublish = 0"
          @after-save-data="afterSaveData"
        >{{ $t("eip.common.save") }}</fe-submit-button>
      </div>
    </eco-sidebar-dialog>

    <fe-load-data :url="loadDataUrl" context="portal" @after-load-data="afterLoadData"></fe-load-data>

    <el-dialog
      title="公众号菜单"
      :visible.sync="wcoaMenuDialogViasible"
      :close-on-click-modal="false"
      width="33%"
      append-to-body
    >
      <el-row>
        <el-col :span="4">
          <el-tooltip placement="top">
            <div slot="content">将右侧URL地址设置在公众号菜单里即可。</div>
            <i class="el-icon-question" />
          </el-tooltip>菜单URL:
        </el-col>
        <el-col :span="20">{{wcoaMenuUrl}}</el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="wcoaMenuDialogViasible = false">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="模板消息ID设置"
      :visible.sync="setTempMsgIdDialogVisible"
      :close-on-click-modal="false"
      width="33%"
      append-to-body
    >
      <el-form data-vv-scope="setTempMsgIdForm">
        <eco-form-item label="模板消息ID">
          <template slot="label">
            <el-tooltip placement="top">
              <div slot="content">在微信公众号后台-功能-模板消息-我的模板-模板消息ID</div>
              <i class="el-icon-question" />
            </el-tooltip>
            <span>模板消息ID</span>
          </template>
          <eco-input
            width="380px"
            v-model="sysExternalUnite.tempMsgId"
            autocomplete="off"
            :validate="{ required: true }"
            placeholder="请输入模板消息ID"
          ></eco-input>
        </eco-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <fe-submit-button
          v-show="!systemDisabled"
          :url="saveSysExternalUnite()"
          :model="sysExternalUnite"
          :is-submit="isSubmit"
          request-method="POST"
          scope-name="setTempMsgIdForm"
          @before-save-data="beforeSaveData"
          @after-save-data="()=>{loadData();setTempMsgIdDialogVisible=false}"
        >{{ $t("eip.common.save") }}</fe-submit-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import sys from "@/api/portal.js";
export default {
  name: "executeJobList",
  components: {},
  data() {
    return {
      typeList: [
        { key: "weChatWork", value: "企业微信" },
        { key: "dingtalk", value: "阿里钉钉" },
        { key: "weChatOffAcc", value: "微信公众号" }
      ],
      sysExternalUnite: {
        id: "",
        corpName: "",
        corpId: "",
        corpSecret: "",
        type: "",
        baseUrl: "",
        agentId: "",
        menuName: "",
        agentKey: "",
        agentSecret: "",
        menuUrl: "",
        tempMsgId: ""
      },
      loadDataUrl: "",
      title: "",
      isSubmit: true,
      dialogVisible: false,
      sysExtUniSetAgentVisible: false,
      systemDisabled: false,
      data: [],
      wcoaMenuUrl: "",
      wcoaMenuDialogViasible: false,
      setTempMsgIdDialogVisible: false
    };
  },

  computed: {},

  mounted() {
    this.loadData();
  },
  methods: {
    dialogCancle() {
      this.loadDataUrl = "";
      this.dialogVisible = false;
      setTimeout(() => (this.systemDisabled = false), 500);
    },
    afterSaveData() {
      this.loadData();
      this.dialogVisible = false;
      this.sysExtUniSetAgentVisible = false;
    },
    beforeSaveData() {
      this.isSubmit = true;
    },
    handleClose() {
      this.dialogVisible = false;
      this.sysExtUniSetAgentVisible = false;
      this.loadDataUrl = "";
      setTimeout(() => (this.systemDisabled = false), 500);
    },
    saveSysExternalUnite: function() {
      return window.context.portal + "/portal/sysExternalUnite/v1/save";
    },
    afterLoadData(data) {
      // 编辑第三方集成信息
      if (this.dialogVisible) {
        this.sysExternalUnite = data;
        setTimeout(() => this.$validator.validateAll("sysExternalUniteForm"));
      }
    },
    showDialog(row) {
      this.dialogVisible = true;
      if (row) {
        this.loadDataUrl = `/portal/sysExternalUnite/v1/getJson?id=${row.id}`;
      }
    },
    loadData() {
      sys.getSysExternalUnitePageJson({}).then(response => {
        this.data = response.rows;
      });
    },
    handleCommand(params) {
      switch (params.command) {
        case "setAgent":
          this.sysExtUniSetAgentVisible = true;
          this.sysExternalUnite = params.row;
          setTimeout(() =>
            this.$validator.validateAll("sysExtUniSetAgentForm")
          );
          break;
        case "edit":
          this.title = "编辑第三方集成信息";
          this.showDialog(params.row);
          break;
        case "add":
          this.sysExternalUnite = {
            id: "",
            corpName: "",
            corpId: "",
            corpSecret: "",
            type: "",
            baseUrl: "",
            agentId: "",
            menuName: "",
            agentKey: "",
            agentSecret: "",
            menuUrl: "",
            tempMsgId: ""
          };
          this.title = "添加第三方集成信息";
          this.showDialog();
          break;
        case "del":
          this.$confirm("是否确认删除？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            sys.delSysExternalUniteById(params.row.id).then(
              data => {
                if (data.state) {
                  this.$message.success(data.message);
                  this.loadData();
                } else {
                  this.$message.error(data.message || "删除失败");
                }
              },
              error => {
                this.$message.error(error || "删除失败");
              }
            );
          });
          break;
        default:
          break;
      }
    },
    syncUser(item) {
      this.$confirm(
        "将同步所有有手机号的用户至第三方通讯录，确定继续操作？",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      ).then(() => {
        const loading = this.$loading({
          lock: true,
          text: "正在同步用户到[" + item.corpName + "]，请等待...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        sys.syncUser(item.id).then(
          data => {
            if (data.state) {
              loading.close();
              this.$message.success(data.message);
              this.loadData();
            } else {
              this.$message.error(data.message || "同步用户失败");
            }
          },
          error => {
            this.$message.error(error || "同步用户失败");
          }
        );
      });
    },
    pullUser(item) {
      this.$confirm("将从第三方拉取通讯录至本系统，确定继续操作？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: "正在拉取通讯录，请等待...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        sys.pullUser(item.id).then(
          data => {
            if (data.state) {
              loading.close();
              this.$message.success(data.message);
              this.loadData();
            } else {
              this.$message.error(data.message || "拉取用户失败");
            }
          },
          error => {
            this.$message.error(error || "拉取用户失败");
          }
        );
      });
    },
    getMenu(item) {
      sys.generateMenuUrl(item.id).then(
        data => {
          if (data.state) {
            this.wcoaMenuDialogViasible = true;
            this.wcoaMenuUrl = data.value;
            // this.$alert(data.value, "拷贝以下链接并将其设置在公众号菜单里", {
            //   confirmButtonText: "确定"
            // });
          } else {
            this.$message.error(data.message || "获取失败");
          }
        },
        error => {
          this.$message.error(error || "获取失败");
        }
      );
    },
    generateMenuUrl(item) {
      sys.generateMenuUrl(item.id).then(
        data => {
          if (data.state) {
            item.menuUrl = data.value;
          } else {
            this.$message.error(data.message || "获取失败");
          }
        },
        error => {
          this.$message.error(error || "获取失败");
        }
      );
    },
    openTempMsgIdDialog(item) {
      this.sysExternalUnite = item;
      this.setTempMsgIdDialogVisible = true;
    },
    saveTempMsgId() {}
  }
};
</script>

<style scoped>
.box-card {
  width: 320;
}
imargin {
  margin-right: 20px;
}

.li {
  width: 56px;
  height: 14px;
  font-size: 14px;
  color: rgba(51, 51, 51, 1);
  line-height: 20px;
}

.bottom {
  margin-top: 13px;
  line-height: 12px;
  padding-bottom: 20px;
}

.divText {
  width: 100px;
  height: 20px;
  font-size: 20px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  line-height: 60px;
}

.image {
  height: 80px;
  margin-left: 12px;
  margin-right: 12px;
  font-size: 60px;
  display: block;
}
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}
.identity-item-bottom {
  margin-bottom: 5px;
}

.identity-input-width .inputs {
  width: 100%;
}
</style>
